module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah M. Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah M. Anderson won RT Reviewer's Choice 2012 Desire of the Year for "), _c('I', [_vm._v("A Man of Privilege")]), _vm._v(". "), _c('I', [_vm._v("The Nanny Plan")]), _vm._v(" was a 2016 RITA® winner for Contemporary Romance: Short. Find out more about Sarah's love of cowboys at www.sarahmanderson.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15q0vIi/tc-custom/9781488002144.jpg?1724862818594",
      "alt": "This image is the cover for the book Rich Rancher for Christmas, The Beaumont Heirs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rich Rancher for Christmas, The Beaumont Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this sexy holiday romance, a celebrity journalist is snowbound with a cowboy she is trying to prove is the illegitimate son of a billionaire patriarch.")]), _c('br'), _c('br'), _vm._v("CJ Wesley values his privacy more than anything. If TV news star Natalie Baker reveals he’s really a Beaumont heir, the media will go wild. That’s when a surprise snowstorm strands the beautiful reporter in his house—and in his bed. Soon he’ll learn how much she’s discovered . . . and how much he wants her. "), _c('br'), _c('br'), _vm._v("CJ defies Natalie’s expectations. The gruff, sexy cowboy knows how to heat up a snowbound cabin and make Christmas magical. Exposing the elusive Beaumont brother will save her job—but only at the price of their passionate connection. It’s a holiday dilemma . . . but will the right choice lead to forever?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0